export const GLOBAL_MAILBOX_CUSTOM_FIELD_PREFIX = 'cfmg_'
export const MAILBOX_CUSTOM_FIELD_PREFIX = 'cfm_'
